export default __webpack_public_path__ + "static/media/518.f80eea5b.jpg";